module.exports = __webpack_public_path__ + "img/2.e992e453.png";